const TagSlugNames = {
  // change to match your environment
  zh: "chinese",
  en: "english",
};

export default TagSlugNames;
